import React from 'react';
import hactivateData from '../../data/hactivate.json';
import crossImg from '../Gigs/gig-cross.svg';
import skillsImg from './skill-hat.svg';
import timerImg from './timer.svg';

const GigDetail = (props) => {

  // Convenienve fn for looking up attributes for a gig id from
  // the gig data
  const getGigAttr = (id, att) => hactivateData.gigs[id][att]; 

  const styles = {
    backgroundColor: '#3CB7D7',
    position: 'relative',
    maxWidth: '320px',
    width: '80vw',
    margin: '0 auto',
    padding: '1em 0'
  }

  const gigId = props.match.params.gigid;

  return (
    <div style={styles}>
      <div className="gigDetail">
        <div className="gigDetailTitle">
          <span className="gigTitle">{ getGigAttr(gigId, 'gigTitle') }</span>
          <span className="gigX"><img src={crossImg} alt=""/></span>
        </div>
        <div className="gigDetailDescription">
          { getGigAttr(gigId, 'gigDesc') }
        </div>

        <div className="gigAttributes">
          <div className="attIcon">
            <img src={skillsImg} alt=""/>
          </div>
          <div className="attribute">
            <span className="gigDetailSkills">
              { getGigAttr(gigId, 'skills') }
            </span>
          </div>

          <div className="attIcon"><img src={timerImg} alt=""/></div>
          <div className="hoursText attribute">
            <span>{ getGigAttr(gigId, 'duration') }</span>
            <span className="hoursLabel">HRS</span>
          </div>

        </div>

        <div className="gigAttributes">
          <div className="attIcon">
          </div>
          <div className="attribute">
          </div>
          <div className="attIcon priceIcon">$</div>
          <div className="attribute priceText">
            <span> { getGigAttr(gigId, 'rate') } </span>
            <span className="priceLabel">P/HR</span>
          </div>
        </div>
      </div>

      <div>
        <a className="acceptGig" href={ getGigAttr(gigId, 'gigURL') }>
          ACCEPT GIG >
        </a>
      </div>
    </div>
  );
}

export default GigDetail;



// WEBPACK FOOTER //
// ./src/components/GigDetail/index.js